import { Popper, Paper, ClickAwayListener } from "@mui/material";
import AccountPopupNotLoggedIn from "./accountPopupNotLoggedIn";
import AccountPopupLoggedIn from "./accountPopupLoggedIn";

const AccountPopup = ({
  open,
  anchorEl,
  onClose,
  isLoggedIn = false,
  userName = "Username",
                          onLoginClick,
    onSignUp
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      sx={{ zIndex: 1300 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          sx={{
            mt: 1,
            width: "254px",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
          }}
        >
          {!isLoggedIn ? (
            <AccountPopupNotLoggedIn onClose={onClose} onLoginClick={onLoginClick} onSignUp={onSignUp} />
          ) : (
            <AccountPopupLoggedIn onClose={onClose} userName={userName} />
          )}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default AccountPopup;
